<template>
    <div class="datafield-validation-condition">
        <datafield-validation-statement
            :statement="condition"
            :datafields="datafields"
            :validation-errors="validationErrors">
            <template v-slot:before>
                <uil-draggabledots />
            </template>

            <template v-slot:after>
                <i @click="deleteCondition()" class="fa fa-trash"></i>
            </template>
        </datafield-validation-statement>
    </div>
</template>
<script>
import DatafieldValidationStatement from './DatafieldValidationStatement.vue';
import { UilDraggabledots } from '@iconscout/vue-unicons';

export default {
    props: {
        condition: {
            type: Object,
            required: true,
        },
        datafields: {
            type: Array,
            required: true,
        },
        validationErrors: {
            type: Object,
        },
    },
    methods: {
        deleteCondition() {
            this.$emit('delete');
        },
    },
    components: {
        DatafieldValidationStatement,
        UilDraggabledots,
    },
};
</script>
